import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  // get<T>(endpoint: string, params?: HttpParams): Observable<T> {
  //   return this.http.get<T>(`${this.baseUrl}${endpoint}`, { params })
  //     .pipe(catchError(this.handleError));
  // }
  get<T>(baseUrl: string, endpoint: string, params?: { [key: string]: string | number | boolean }, headers?: HttpHeaders): Observable<T> {
    const httpParams = new HttpParams({
      fromObject: params || {},
    });
  
    return this.http.get<T>(`${baseUrl}${endpoint}`, { headers, params: httpParams })
      .pipe(
        catchError(this.handleError),
        timeout(300000)
      );
  }
  
  post<T>(baseUrl: string, endpoint: string, body: any, headers?: HttpHeaders): Observable<T> {
    // headers?.set('Content-Type', 'application/json');
    return this.http.post<T>(`${baseUrl}${endpoint}`, body, { headers })
      .pipe(catchError(this.handleError),
      timeout(300000));
  }


  postData<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    // headers?.set('Content-Type', 'application/json');
    return this.http.post<T>(`${url}`, body, { headers })
      .pipe(catchError(this.handleError),
      timeout(300000));
  }

  private handleError(error: any): Observable<never> {
    // Handle error silently
    throw error;
  }
}
